var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "permissions-view" },
    [
      _c("div", { staticClass: "row permissions-container" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center justify-content-between"
            },
            [_c("back-arrow", { attrs: { title: _vm.$t("Autorisations") } })],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 mt-2 permission-item" },
          [
            _vm.showAlert
              ? _c(
                  "b-alert",
                  {
                    staticClass: "mt-2",
                    attrs: { variant: "danger", show: "" },
                    on: {
                      close: function($event) {
                        return _vm.closeAlert()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("autorisation.Denied")) +
                        "\n      "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex align-items-center permission-toggle" },
              [
                _c(
                  "label",
                  {
                    staticClass: "permission-label mr-3",
                    attrs: { for: "pushNotifications" }
                  },
                  [_vm._v(_vm._s(_vm.$t("autorisation.notification.title")))]
                ),
                _vm._v(" "),
                _c("b-form-checkbox", {
                  attrs: {
                    size: "lg",
                    id: "pushNotifications",
                    checked: _vm.permissions.pushNotifications,
                    switch: ""
                  },
                  on: { change: _vm.toggleNotificationPermission }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("p", { staticClass: "card p-3 description" }, [
              _vm._v(_vm._s(_vm.$t("autorisation.notification.text")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "param-notif mb-2 cursor-pointer",
                on: {
                  click: function($event) {
                    return _vm.openParamModal()
                  }
                }
              },
              [
                _c("div", [_vm._v(_vm._s(_vm.$t("autorisation.Params")))]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M14.1922 10.4422L7.94219 16.6922C7.85478 16.7797 7.74337 16.8393 7.62207 16.8635C7.50076 16.8876 7.37502 16.8752 7.26076 16.8279C7.14649 16.7805 7.04884 16.7004 6.98017 16.5975C6.91151 16.4946 6.8749 16.3737 6.875 16.25V3.75C6.8749 3.62632 6.91151 3.50539 6.98017 3.40252C7.04884 3.29964 7.14649 3.21946 7.26076 3.17211C7.37502 3.12477 7.50076 3.11239 7.62207 3.13655C7.74337 3.1607 7.85478 3.22031 7.94219 3.30782L14.1922 9.55782C14.2503 9.61586 14.2964 9.68479 14.3279 9.76067C14.3593 9.83654 14.3755 9.91787 14.3755 10C14.3755 10.0821 14.3593 10.1635 14.3279 10.2393C14.2964 10.3152 14.2503 10.3841 14.1922 10.4422Z",
                          fill: "#EAEAEA"
                        }
                      })
                    ]
                  )
                ])
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 mt-2 permission-item" }, [
          _c(
            "div",
            { staticClass: "d-flex align-items-center permission-toggle" },
            [
              _c(
                "label",
                {
                  staticClass: "permission-label mr-3",
                  attrs: { for: "geoloc" }
                },
                [_vm._v(_vm._s(_vm.$t("autorisation.geolocations.title")))]
              ),
              _vm._v(" "),
              _c("b-form-checkbox", {
                attrs: {
                  size: "lg",
                  id: "geoloc",
                  checked: _vm.permissions.geolocations,
                  switch: ""
                },
                on: { change: _vm.toggleGeolocationPermission }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "card p-3 description" }, [
            _vm._v(_vm._s(_vm.$t("autorisation.geolocations.text")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 mt-2 permission-item" }, [
          _c(
            "div",
            { staticClass: "d-flex align-items-center permission-toggle" },
            [
              _c(
                "label",
                {
                  staticClass: "permission-label mr-3",
                  attrs: { for: "cameraAccess" }
                },
                [_vm._v(_vm._s(_vm.$t("autorisation.camera.title")))]
              ),
              _vm._v(" "),
              _c("b-form-checkbox", {
                attrs: {
                  size: "lg",
                  id: "cameraAccess",
                  checked: _vm.permissions.cameraAccess,
                  switch: ""
                },
                on: { change: _vm.toggleCameraPermission }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "card p-3 description" }, [
            _vm._v(_vm._s(_vm.$t("autorisation.camera.text")))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("notif-param-modal")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48d2b3fd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48d2b3fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/autorisations/Autorisations.vue
// module id = fM1v
// module chunks = 0